export interface CountryInfo {
  iso2: string;
  iso3: string;
  numericId: string;
  name: string;
  flag: string;
}

const COUNTRY_DATABASE: Record<string, CountryInfo> = {
  us: { iso2: "US", iso3: "USA", numericId: "840", name: "United States", flag: "🇺🇸" },
  usa: { iso2: "US", iso3: "USA", numericId: "840", name: "United States", flag: "🇺🇸" },
  "840": { iso2: "US", iso3: "USA", numericId: "840", name: "United States", flag: "🇺🇸" },
  "united states": { iso2: "US", iso3: "USA", numericId: "840", name: "United States", flag: "🇺🇸" },
  "united states of america": { iso2: "US", iso3: "USA", numericId: "840", name: "United States", flag: "🇺🇸" },

  gb: { iso2: "GB", iso3: "GBR", numericId: "826", name: "United Kingdom", flag: "🇬🇧" },
  gbr: { iso2: "GB", iso3: "GBR", numericId: "826", name: "United Kingdom", flag: "🇬🇧" },
  uk: { iso2: "GB", iso3: "GBR", numericId: "826", name: "United Kingdom", flag: "🇬🇧" },
  "826": { iso2: "GB", iso3: "GBR", numericId: "826", name: "United Kingdom", flag: "🇬🇧" },
  "united kingdom": { iso2: "GB", iso3: "GBR", numericId: "826", name: "United Kingdom", flag: "🇬🇧" },
  "great britain": { iso2: "GB", iso3: "GBR", numericId: "826", name: "United Kingdom", flag: "🇬🇧" },

  ca: { iso2: "CA", iso3: "CAN", numericId: "124", name: "Canada", flag: "🇨🇦" },
  can: { iso2: "CA", iso3: "CAN", numericId: "124", name: "Canada", flag: "🇨🇦" },
  "124": { iso2: "CA", iso3: "CAN", numericId: "124", name: "Canada", flag: "🇨🇦" },
  canada: { iso2: "CA", iso3: "CAN", numericId: "124", name: "Canada", flag: "🇨🇦" },

  in: { iso2: "IN", iso3: "IND", numericId: "356", name: "India", flag: "🇮🇳" },
  ind: { iso2: "IN", iso3: "IND", numericId: "356", name: "India", flag: "🇮🇳" },
  "356": { iso2: "IN", iso3: "IND", numericId: "356", name: "India", flag: "🇮🇳" },
  india: { iso2: "IN", iso3: "IND", numericId: "356", name: "India", flag: "🇮🇳" },

  id: { iso2: "ID", iso3: "IDN", numericId: "360", name: "Indonesia", flag: "🇮🇩" },
  idn: { iso2: "ID", iso3: "IDN", numericId: "360", name: "Indonesia", flag: "🇮🇩" },
  "360": { iso2: "ID", iso3: "IDN", numericId: "360", name: "Indonesia", flag: "🇮🇩" },
  indonesia: { iso2: "ID", iso3: "IDN", numericId: "360", name: "Indonesia", flag: "🇮🇩" },

  ir: { iso2: "IR", iso3: "IRN", numericId: "364", name: "Iran", flag: "🇮🇷" },
  irn: { iso2: "IR", iso3: "IRN", numericId: "364", name: "Iran", flag: "🇮🇷" },
  "364": { iso2: "IR", iso3: "IRN", numericId: "364", name: "Iran", flag: "🇮🇷" },
  iran: { iso2: "IR", iso3: "IRN", numericId: "364", name: "Iran", flag: "🇮🇷" },

  es: { iso2: "ES", iso3: "ESP", numericId: "724", name: "Spain", flag: "🇪🇸" },
  esp: { iso2: "ES", iso3: "ESP", numericId: "724", name: "Spain", flag: "🇪🇸" },
  "724": { iso2: "ES", iso3: "ESP", numericId: "724", name: "Spain", flag: "🇪🇸" },
  spain: { iso2: "ES", iso3: "ESP", numericId: "724", name: "Spain", flag: "🇪🇸" },

  au: { iso2: "AU", iso3: "AUS", numericId: "036", name: "Australia", flag: "🇦🇺" },
  aus: { iso2: "AU", iso3: "AUS", numericId: "036", name: "Australia", flag: "🇦🇺" },
  "036": { iso2: "AU", iso3: "AUS", numericId: "036", name: "Australia", flag: "🇦🇺" },
  "36": { iso2: "AU", iso3: "AUS", numericId: "036", name: "Australia", flag: "🇦🇺" },
  australia: { iso2: "AU", iso3: "AUS", numericId: "036", name: "Australia", flag: "🇦🇺" },

  hk: { iso2: "HK", iso3: "HKG", numericId: "344", name: "Hong Kong", flag: "🇭🇰" },
  hkg: { iso2: "HK", iso3: "HKG", numericId: "344", name: "Hong Kong", flag: "🇭🇰" },
  "344": { iso2: "HK", iso3: "HKG", numericId: "344", name: "Hong Kong", flag: "🇭🇰" },
  "hong kong": { iso2: "HK", iso3: "HKG", numericId: "344", name: "Hong Kong", flag: "🇭🇰" },

  tw: { iso2: "TW", iso3: "TWN", numericId: "158", name: "Taiwan", flag: "🇹🇼" },
  twn: { iso2: "TW", iso3: "TWN", numericId: "158", name: "Taiwan", flag: "🇹🇼" },
  "158": { iso2: "TW", iso3: "TWN", numericId: "158", name: "Taiwan", flag: "🇹🇼" },
  taiwan: { iso2: "TW", iso3: "TWN", numericId: "158", name: "Taiwan", flag: "🇹🇼" },

  fr: { iso2: "FR", iso3: "FRA", numericId: "250", name: "France", flag: "🇫🇷" },
  fra: { iso2: "FR", iso3: "FRA", numericId: "250", name: "France", flag: "🇫🇷" },
  "250": { iso2: "FR", iso3: "FRA", numericId: "250", name: "France", flag: "🇫🇷" },
  france: { iso2: "FR", iso3: "FRA", numericId: "250", name: "France", flag: "🇫🇷" },

  de: { iso2: "DE", iso3: "DEU", numericId: "276", name: "Germany", flag: "🇩🇪" },
  deu: { iso2: "DE", iso3: "DEU", numericId: "276", name: "Germany", flag: "🇩🇪" },
  "276": { iso2: "DE", iso3: "DEU", numericId: "276", name: "Germany", flag: "🇩🇪" },
  germany: { iso2: "DE", iso3: "DEU", numericId: "276", name: "Germany", flag: "🇩🇪" },

  br: { iso2: "BR", iso3: "BRA", numericId: "076", name: "Brazil", flag: "🇧🇷" },
  bra: { iso2: "BR", iso3: "BRA", numericId: "076", name: "Brazil", flag: "🇧🇷" },
  "076": { iso2: "BR", iso3: "BRA", numericId: "076", name: "Brazil", flag: "🇧🇷" },
  "76": { iso2: "BR", iso3: "BRA", numericId: "076", name: "Brazil", flag: "🇧🇷" },
  brazil: { iso2: "BR", iso3: "BRA", numericId: "076", name: "Brazil", flag: "🇧🇷" },

  ma: { iso2: "MA", iso3: "MAR", numericId: "504", name: "Morocco", flag: "🇲🇦" },
  mar: { iso2: "MA", iso3: "MAR", numericId: "504", name: "Morocco", flag: "🇲🇦" },
  "504": { iso2: "MA", iso3: "MAR", numericId: "504", name: "Morocco", flag: "🇲🇦" },
  morocco: { iso2: "MA", iso3: "MAR", numericId: "504", name: "Morocco", flag: "🇲🇦" },

  sa: { iso2: "SA", iso3: "SAU", numericId: "682", name: "Saudi Arabia", flag: "🇸🇦" },
  sau: { iso2: "SA", iso3: "SAU", numericId: "682", name: "Saudi Arabia", flag: "🇸🇦" },
  "682": { iso2: "SA", iso3: "SAU", numericId: "682", name: "Saudi Arabia", flag: "🇸🇦" },
  "saudi arabia": { iso2: "SA", iso3: "SAU", numericId: "682", name: "Saudi Arabia", flag: "🇸🇦" },

  mx: { iso2: "MX", iso3: "MEX", numericId: "484", name: "Mexico", flag: "🇲🇽" },
  mex: { iso2: "MX", iso3: "MEX", numericId: "484", name: "Mexico", flag: "🇲🇽" },
  "484": { iso2: "MX", iso3: "MEX", numericId: "484", name: "Mexico", flag: "🇲🇽" },
  mexico: { iso2: "MX", iso3: "MEX", numericId: "484", name: "Mexico", flag: "🇲🇽" },

  it: { iso2: "IT", iso3: "ITA", numericId: "380", name: "Italy", flag: "🇮🇹" },
  ita: { iso2: "IT", iso3: "ITA", numericId: "380", name: "Italy", flag: "🇮🇹" },
  "380": { iso2: "IT", iso3: "ITA", numericId: "380", name: "Italy", flag: "🇮🇹" },
  italy: { iso2: "IT", iso3: "ITA", numericId: "380", name: "Italy", flag: "🇮🇹" },

  ua: { iso2: "UA", iso3: "UKR", numericId: "804", name: "Ukraine", flag: "🇺🇦" },
  ukr: { iso2: "UA", iso3: "UKR", numericId: "804", name: "Ukraine", flag: "🇺🇦" },
  "804": { iso2: "UA", iso3: "UKR", numericId: "804", name: "Ukraine", flag: "🇺🇦" },
  ukraine: { iso2: "UA", iso3: "UKR", numericId: "804", name: "Ukraine", flag: "🇺🇦" },

  ae: { iso2: "AE", iso3: "ARE", numericId: "784", name: "United Arab Emirates", flag: "🇦🇪" },
  are: { iso2: "AE", iso3: "ARE", numericId: "784", name: "United Arab Emirates", flag: "🇦🇪" },
  uae: { iso2: "AE", iso3: "ARE", numericId: "784", name: "United Arab Emirates", flag: "🇦🇪" },
  "784": { iso2: "AE", iso3: "ARE", numericId: "784", name: "United Arab Emirates", flag: "🇦🇪" },
  "united arab emirates": { iso2: "AE", iso3: "ARE", numericId: "784", name: "United Arab Emirates", flag: "🇦🇪" },

  cn: { iso2: "CN", iso3: "CHN", numericId: "156", name: "China", flag: "🇨🇳" },
  chn: { iso2: "CN", iso3: "CHN", numericId: "156", name: "China", flag: "🇨🇳" },
  "156": { iso2: "CN", iso3: "CHN", numericId: "156", name: "China", flag: "🇨🇳" },
  china: { iso2: "CN", iso3: "CHN", numericId: "156", name: "China", flag: "🇨🇳" },

  jp: { iso2: "JP", iso3: "JPN", numericId: "392", name: "Japan", flag: "🇯🇵" },
  jpn: { iso2: "JP", iso3: "JPN", numericId: "392", name: "Japan", flag: "🇯🇵" },
  "392": { iso2: "JP", iso3: "JPN", numericId: "392", name: "Japan", flag: "🇯🇵" },
  japan: { iso2: "JP", iso3: "JPN", numericId: "392", name: "Japan", flag: "🇯🇵" },

  kr: { iso2: "KR", iso3: "KOR", numericId: "410", name: "South Korea", flag: "🇰🇷" },
  kor: { iso2: "KR", iso3: "KOR", numericId: "410", name: "South Korea", flag: "🇰🇷" },
  "410": { iso2: "KR", iso3: "KOR", numericId: "410", name: "South Korea", flag: "🇰🇷" },
  "south korea": { iso2: "KR", iso3: "KOR", numericId: "410", name: "South Korea", flag: "🇰🇷" },

  ru: { iso2: "RU", iso3: "RUS", numericId: "643", name: "Russia", flag: "🇷🇺" },
  rus: { iso2: "RU", iso3: "RUS", numericId: "643", name: "Russia", flag: "🇷🇺" },
  "643": { iso2: "RU", iso3: "RUS", numericId: "643", name: "Russia", flag: "🇷🇺" },
  russia: { iso2: "RU", iso3: "RUS", numericId: "643", name: "Russia", flag: "🇷🇺" },

  sg: { iso2: "SG", iso3: "SGP", numericId: "702", name: "Singapore", flag: "🇸🇬" },
  sgp: { iso2: "SG", iso3: "SGP", numericId: "702", name: "Singapore", flag: "🇸🇬" },
  "702": { iso2: "SG", iso3: "SGP", numericId: "702", name: "Singapore", flag: "🇸🇬" },
  singapore: { iso2: "SG", iso3: "SGP", numericId: "702", name: "Singapore", flag: "🇸🇬" },

  nl: { iso2: "NL", iso3: "NLD", numericId: "528", name: "Netherlands", flag: "🇳🇱" },
  nld: { iso2: "NL", iso3: "NLD", numericId: "528", name: "Netherlands", flag: "🇳🇱" },
  "528": { iso2: "NL", iso3: "NLD", numericId: "528", name: "Netherlands", flag: "🇳🇱" },
  netherlands: { iso2: "NL", iso3: "NLD", numericId: "528", name: "Netherlands", flag: "🇳🇱" },

  ch: { iso2: "CH", iso3: "CHE", numericId: "756", name: "Switzerland", flag: "🇨🇭" },
  che: { iso2: "CH", iso3: "CHE", numericId: "756", name: "Switzerland", flag: "🇨🇭" },
  "756": { iso2: "CH", iso3: "CHE", numericId: "756", name: "Switzerland", flag: "🇨🇭" },
  switzerland: { iso2: "CH", iso3: "CHE", numericId: "756", name: "Switzerland", flag: "🇨🇭" },

  se: { iso2: "SE", iso3: "SWE", numericId: "752", name: "Sweden", flag: "🇸🇪" },
  swe: { iso2: "SE", iso3: "SWE", numericId: "752", name: "Sweden", flag: "🇸🇪" },
  "752": { iso2: "SE", iso3: "SWE", numericId: "752", name: "Sweden", flag: "🇸🇪" },
  sweden: { iso2: "SE", iso3: "SWE", numericId: "752", name: "Sweden", flag: "🇸🇪" },

  pl: { iso2: "PL", iso3: "POL", numericId: "616", name: "Poland", flag: "🇵🇱" },
  pol: { iso2: "PL", iso3: "POL", numericId: "616", name: "Poland", flag: "🇵🇱" },
  "616": { iso2: "PL", iso3: "POL", numericId: "616", name: "Poland", flag: "🇵🇱" },
  poland: { iso2: "PL", iso3: "POL", numericId: "616", name: "Poland", flag: "🇵🇱" },

  tr: { iso2: "TR", iso3: "TUR", numericId: "792", name: "Turkey", flag: "🇹🇷" },
  tur: { iso2: "TR", iso3: "TUR", numericId: "792", name: "Turkey", flag: "🇹🇷" },
  "792": { iso2: "TR", iso3: "TUR", numericId: "792", name: "Turkey", flag: "🇹🇷" },
  turkey: { iso2: "TR", iso3: "TUR", numericId: "792", name: "Turkey", flag: "🇹🇷" },

  il: { iso2: "IL", iso3: "ISR", numericId: "376", name: "Israel", flag: "🇮🇱" },
  isr: { iso2: "IL", iso3: "ISR", numericId: "376", name: "Israel", flag: "🇮🇱" },
  "376": { iso2: "IL", iso3: "ISR", numericId: "376", name: "Israel", flag: "🇮🇱" },
  israel: { iso2: "IL", iso3: "ISR", numericId: "376", name: "Israel", flag: "🇮🇱" },
};

export function getFlagEmoji(countryCode: string): string {
  if (!countryCode || countryCode.length !== 2) return "🌐";
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}

export function normalizeCountry(input: string, inputCode?: string): CountryInfo {
  if (!input && !inputCode) {
    return { iso2: "XX", iso3: "XXX", numericId: "000", name: "Unknown", flag: "🌐" };
  }

  const rawKey = (input || "").trim().toLowerCase();
  const rawCode = (inputCode || "").trim().toLowerCase();

  if (rawCode && COUNTRY_DATABASE[rawCode]) {
    return COUNTRY_DATABASE[rawCode];
  }

  if (rawKey && COUNTRY_DATABASE[rawKey]) {
    return COUNTRY_DATABASE[rawKey];
  }

  // Padded numeric lookup (e.g., '36' -> '036')
  if (/^\d+$/.test(rawCode)) {
    const padded = rawCode.padStart(3, "0");
    if (COUNTRY_DATABASE[padded]) return COUNTRY_DATABASE[padded];
  }
  if (/^\d+$/.test(rawKey)) {
    const padded = rawKey.padStart(3, "0");
    if (COUNTRY_DATABASE[padded]) return COUNTRY_DATABASE[padded];
  }

  const iso2 = (rawCode || rawKey.substring(0, 2)).toUpperCase();
  const flag = iso2.length === 2 ? getFlagEmoji(iso2) : "🌐";
  const name = input || inputCode || "Unknown";

  return { iso2, iso3: iso2 + "X", numericId: "000", name, flag };
}
